<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<h3 class="text-white">{{ $t('Invoice') }}</h3>
		</template>
		<template slot="body">
			<div v-if="!isCustomInvoice">
				<div class="text-center">
					<loading :active.sync="isFetching" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
						<template slot="after">
							<div class="absolute mt-1 ml-1 text-center">{{ $t('Getting invoice ...') }}</div>
						</template>
					</loading>
				</div>
				<div class="text-center mt-2">
					<img src="/img/logo/grafias_medium_ondark.png" alt="xls" width="200px"/>
				</div>
				<div v-if="invoiceItem">
					<!-- Title Head-->
					<div class="text-center mt-2">
						<h4>{{ $t('Receipt from ') }}{{invoiceItem && invoiceItem.account_name}}</h4>
						<h6>{{ $t('Invoice ') }}{{`#${invoiceItem && invoiceItem.number}`}}</h6>
					</div>
					<!-- line 2 (payemnt) -->
					<div class="d-flex text-center mt-4 justify-content-between">
						<div class="text-center w-100" :class="{'text-black': !invoiceItem.default_payment_method}"><h5>{{ $t('Amount Paid') }}</h5></div>
						<div class="w-100" v-if="!invoiceItem.default_payment_method"></div>
						<div class="text-center w-100"><h5>{{ $t('Date Paid') }}</h5></div>
						<div class="text-center w-100" v-if="invoiceItem && invoiceItem.default_payment_method"><h5>{{ $t('Payment Method') }}</h5></div>
					</div>
					<div class="d-flex text-center justify-content-between">
						<div class="text-center text-xlg w-100 text-primary">{{ amountPaid(invoiceItem && invoiceItem.amount_paid) }}</div>
						<div class="w-100" v-if="!invoiceItem.default_payment_method"></div>
						<div class="text-center text-xlg w-100">{{ convertTimestamp(invoiceItem && invoiceItem.created) }}</div>
						<div class="text-center w-100" v-if="invoiceItem && invoiceItem.default_payment_method">{{ (invoiceItem && invoiceItem.default_payment_method ? invoiceItem.default_payment_method : '-') }}</div>
					</div>
					<!-- line 3 (summary) -->
					<div class="row text-center mt-4">
						<div class="ml-4 pl-3"><h5>{{ $t('Summary') }}</h5></div>
					</div>
					<div class="invoice-summary">
						<!-- Package Name -->
						<div v-for="(item, index) in invoiceItem.lines.data" :key="index">
						<!-- date -->
							<div>{{convertTimestamp(item && item.period.start)}} - {{convertTimestamp(item && item.period.end)}}</div>
							<div class="d-flex justify-content-between mt-2">
								<div>{{item.description}}</div>
								<div>{{ amountPaid(item && item.price.unit_amount)}}</div>
							</div>
						</div>
						<mdDivider></mdDivider>
						<!-- Subtotal -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Subtotal')}}</div>
							<div>{{ amountPaid(invoiceItem && invoiceItem.subtotal)}}</div>
						</div>
						<!-- Total Discount Amount -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Total Discount')}}</div>
							<div v-if="invoiceItem && invoiceItem.total_discount_amounts.length >= 1">
								<div v-for="(itemDiscount, indexDiscount) in invoiceItem.total_discount_amounts" :key="indexDiscount">
									<div>{{ amountPaid(itemDiscount.amount) }} </div>
								</div>
							</div>
							<div v-else>
								<div> $0 </div>
							</div>
						</div>
						<!-- Amount Paid -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Amount Paid')}}</div>
							<div>{{ amountPaid(invoiceItem && invoiceItem.total)}}</div>
						</div>
					</div>
					<!-- generate pdf -->
					<div>
						<vue-html2pdf
							:show-layout="false"
							:float-layout="true"
							:enable-download="true"
							:paginate-elements-by-height="1100"
							:filename=nameInvoicePdf
							:pdf-quality="2"
							:manual-pagination="false"
							pdf-format="a4"
							pdf-orientation="portrait"
							pdf-content-width="800px"
							ref="html2Pdf"
						>
							<section slot="pdf-content" class="invoice-body">
								<section class="pdf-item text-black p-5em">
									<!-- line 1 title -->
									<div class="d-flex justify-content-between">
										<div>
											<img src="/img/logo/grafias_large_onwhite.png" alt="xls" width="200px"/>
											<!-- <h2 class="text-navy">Grafias</h2> -->
										</div>
										<div>
											<h2 class="text-navy-light">Receipt</h2>
										</div>
									</div>
									<!-- line 2 title -->
									<div class="d-flex justify-content-between">
										<div class="text-grey pt-3 mb-3">
											<div class="text-navy-light">SuperSource, Inc</div>
											<div class="text-navy-light">8 The Green</div>
											<div class="text-navy-light">Suite 12214</div>
											<div class="text-navy-light">Dover, DE 19901</div>
											<div class="text-navy-light">United States</div>
											<div class="text-navy-light">1 (302) 289-8007</div>
											<div class="text-navy">billing@grafiaslive.com</div>
										</div>
										<div class="text-black mt-2">
											<div class="d-flex justify-content-between mb-0" v-if="invoiceItem && invoiceItem.receipt_number">
												<label class="mr-4 text-navy-light">Receipt number</label>
												<label class="text-navy">{{invoiceItem && invoiceItem.receipt_number}}</label>
											</div>
											<div class="d-flex justify-content-between mb-0">
												<label class="mr-4 text-navy-light">Invoice number</label>
												<label class="text-navy">{{invoiceItem && invoiceItem.number}}</label>
											</div>
											<div class="d-flex justify-content-between mb-0">
												<label class="mr-4 text-navy-light">Date paid</label>
												<label class="text-navy">{{convertTimestampComplete(invoiceItem && invoiceItem.created)}}</label>
											</div>
											<div class="d-flex justify-content-between" v-if="invoiceItem && invoiceItem.payment_method_details && invoiceItem.payment_method_details.card">
												<label class="mr-4 text-navy-light">Payment Method</label>
												<label class="text-navy">
													<span v-if="brandCard === 'mastercard'"><img src="/img/mastercard.png" alt="xls" width="60px"/></span>
													<span v-else-if="brandCard === 'visa'"><img src="/img/visa.jpg" alt="xls" width="60px"/></span>
													<span v-else>{{brandCard}}</span>
													- {{last4DigitCard}}
												</label>
											</div>
										</div>
									</div>
									<!-- line 3 bill to-->
									<div class="d-flex justify-content-between">
										<div class="text-grey mt-2">
											<div class="text-navy mb-1">Paid by</div>
											<div class="mb-1 text-navy-light">{{invoiceItem && invoiceItem.customer_name}}</div>
											<div class="mb-0 text-navy-light">{{invoiceItem && invoiceItem.customer_email}}</div>
										</div>
									</div>
									<!-- line 4 total payment -->
									<div class="d-flex">
										<div class="d-flex mt-5 mb-4 text-navy">
											<h2 class="text-navy mr-2">{{amountPaid(invoiceItem && invoiceItem.total)}}</h2><h2 class="text-navy" v-if="invoiceItem && invoiceItem.created">paid on {{convertTimestampComplete(invoiceItem && invoiceItem.created)}}</h2>
										</div>
									</div>
									<!-- table -->
									<table class="table mb-4 bg-white-tb table-striped-grey text-small"
									:class="{'mb-25': invoiceItem && invoiceItem.total_discount_amounts.length === 0,
											'mb-22': invoiceItem && invoiceItem.total_discount_amounts.length >= 1}">
									<thead>
										<tr class="text-navy">
											<th width="55%" class="fs-13px">{{ $t('Description') }}</th>
											<th class="fs-13px">{{ $t('Qty') }}</th>
											<th class="fs-13px">{{ $t('Unit Price') }}</th>
											<th class="fs-13px">{{ $t('Amount') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr class="border-bottom"
											v-for="(item, index) in invoiceItem.lines.data" :key="index">
											<td class="bg-white-top">
												<div class="mb-4">{{convertTimestamp(item && item.period.start)}} - {{convertTimestamp(item && item.period.end)}}</div>
												<div class="truncate-invoice-title">{{ item.description }}</div>
											</td>
											<td><div class="mb-5"></div>{{ item.quantity }}</td>
											<td><div class="mb-5"></div>{{ amountPaid(item.price.unit_amount) }}</td>
											<td><div class="mb-5"></div>{{ amountPaid(item.price.unit_amount * item.quantity) }}</td>
										</tr>
										<tr>
											<td class="bg-white"></td><td class="bg-white"></td>
											<td class="bg-navy-light border-bottom">Subtotal</td>
											<td class="bg-navy-light border-bottom">{{ amountPaid(invoiceItem && invoiceItem.subtotal) }}</td>
										</tr>
										<tr v-if="invoiceItem && invoiceItem.total_discount_amounts.length > 0">
											<td class="bg-white"></td>
											<td class="bg-white"></td>
											<td>Total Discount</td>
											<div v-if="invoiceItem && invoiceItem.total_discount_amounts.length >= 1">
												<div v-for="(itemDiscount, indexDiscount) in invoiceItem.total_discount_amounts" :key="indexDiscount">
													<td class="bg-navy-light">{{ amountPaid(itemDiscount.amount) }}</td>
												</div>
											</div>
											<div v-else>
												<td class="bg-navy-light">$0</td>
											</div>
										</tr>
										<tr>
											<td class="bg-white"></td><td class="bg-white"></td>
											<td class="bg-amount-paid">Amount Due</td>
											<td class="bg-amount-paid">{{ amountPaid(invoiceItem && invoiceItem.amount_due) }}</td>
										</tr>
									</tbody>
								</table>
								<div><hr></div>
								<div style="position: absoulte; bottom: 0;">Terms and conditions apply <a class="text-navy" href="https://grafiaslive.com/terms-and-condition-23-july-2020/">https://grafiaslive.com/terms-and-condition-23-july-2020/</a></div>
								<span class="text-navy mr-1">Questions?</span><span>Contact SuperSource, Inc at <span class="text-navy mr-1">billing@grafiaslive.com</span> or call at <span class="text-navy mr-1">+1 (302) 289-8007</span>.</span>
								</section>
							</section>
						</vue-html2pdf>
					</div>
					<div @click="generateReport()" class="text-primary ml-3 pl-2 pointer mb-3">Download invoice as PDF</div>
				</div>
			</div>
			<!-- custom invoice -->
			<div v-if="isCustomInvoice">
				<div class="text-center">
					<loading :active.sync="isFetching" :is-full-page="fullPage" :background-color="colorOverlay" :color="colorLoading">
						<template slot="after">
							<div class="absolute mt-1 ml-1 text-center">{{ $t('Getting invoice ...') }}</div>
						</template>
					</loading>
				</div>
				<div class="text-center mt-2">
					<img src="/img/logo/grafias_medium_ondark.png" alt="xls" width="200px"/>
				</div>
				<div v-if="invoiceItem">
					<!-- Title Head-->
					<div class="text-center mt-2">
						<h4>{{ $t('Receipt from ') }}{{invoiceItem && customNameInvoice}}</h4>
						<h6>{{ $t('Custom - Invoice ') }}{{`#${invoiceItem && invoiceItem.invoice_number}`}}</h6>
					</div>
					<!-- line 2 (payemnt) -->
					<div class="d-flex text-center mt-4 justify-content-between">
						<div class="text-center w-100" :class="{'text-black': !invoiceItem.payment_method}"><h5>{{ $t('Amount Paid') }}</h5></div>
						<div class="w-100" v-if="!invoiceItem.payment_method"></div>
						<div class="text-center w-100"><h5>{{ $t('Date Paid') }}</h5></div>
						<div class="text-center w-100" v-if="invoiceItem && invoiceItem.payment_method"><h5>{{ $t('Payment Method') }}</h5></div>
					</div>
					<div class="d-flex text-center justify-content-between">
						<div class="text-center text-xlg w-100 text-primary">{{ amountPaidCustom(invoiceItem && invoiceItem.amount) }}</div>
						<div class="w-100" v-if="!invoiceItem.payment_method"></div>
						<div class="text-center text-xlg w-100">{{ convertTimestampCustom(invoiceItem && invoiceItem.due_date) }}</div>
						<div class="text-center w-100" v-if="invoiceItem && invoiceItem.payment_method">{{ (invoiceItem && invoiceItem.payment_method ? invoiceItem.payment_method : '-') }}</div>
					</div>
					<!-- line 3 (summary) -->
					<div class="row text-center mt-4">
						<div class="ml-4 pl-3"><h5>{{ $t('Summary') }}</h5></div>
					</div>
					<div class="invoice-summary">
						<!-- Package Name -->
						<div>
						<!-- date -->
							<div>{{convertTimestampCustom(invoiceItem && invoiceItem.due_date)}}</div>
							<div class="d-flex justify-content-between mt-2">
								<div class="truncate-description-invoice">{{invoiceItem && invoiceItem.description}}</div>
								<div>{{ amountPaidCustom(invoiceItem && customPrice)}}</div>
							</div>
						</div>
						<mdDivider></mdDivider>
						<!-- Total Discount Amount -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Total Discount')}}</div>
							<div v-if="invoiceItem && customDiscount">
									<div>{{ amountPaidCustom(invoiceItem && customDiscount) }} </div>
							</div>
							<div v-else>
								<div> $0 </div>
							</div>
						</div>
						<!-- Amount Paid -->
						<div class="d-flex justify-content-between mt-2">
							<div>{{$t('Amount Paid')}}</div>
							<div>{{ amountPaidCustom(invoiceItem && invoiceItem.amount)}}</div>
						</div>
					</div>
					<!-- generate pdf -->
					<div>
						<vue-html2pdf
							:show-layout="false"
							:float-layout="true"
							:enable-download="true"
							:paginate-elements-by-height="1100"
							:filename=nameInvoicePdf
							:pdf-quality="2"
							:manual-pagination="true"
							pdf-format="a4"
							pdf-orientation="portrait"
							pdf-content-width="800px"
							ref="html2Pdf"
						>
							<section slot="pdf-content" class="invoice-body">
								<section class="pdf-item text-black p-5em">
									<!-- line 1 title -->
									<div class="d-flex justify-content-between">
										<div>
											<img src="/img/logo/grafias_large_onwhite.png" alt="xls" width="200px"/>
											<!-- <h2 class="text-navy">Grafias</h2> -->
										</div>
										<div>
											<h2 class="text-navy-light">Receipt</h2>
										</div>
									</div>
									<!-- line 2 title -->
									<div class="d-flex justify-content-between">
										<div class="text-grey pt-3 mb-3">
											<div class="text-navy-light">SuperSource, Inc</div>
											<div class="text-navy-light">8 The Green</div>
											<div class="text-navy-light">Suite 12214</div>
											<div class="text-navy-light">Dover, DE 19901</div>
											<div class="text-navy-light">United States</div>
											<div class="text-navy-light">1 (302) 289-8007</div>
											<div class="text-navy">billing@grafiaslive.com</div>
										</div>
										<div class="text-black mt-2">
											<div class="d-flex justify-content-between mb-0">
												<label class="mr-4 text-navy-light">Invoice number</label>
												<label class="text-navy">{{invoiceItem && invoiceItem.invoice_number}}</label>
											</div>
											<div class="d-flex justify-content-between mb-0">
												<label class="mr-4 text-navy-light">Date paid</label>
												<label class="text-navy">{{convertTimestampCompleteCustom(invoiceItem && invoiceItem.due_date)}}</label>
											</div>
											<div class="d-flex justify-content-between" v-if="invoiceItem && invoiceItem.payment_method">
												<label class="mr-4 text-navy-light">Payment Method</label>
												<label class="text-navy">
													{{invoiceItem && invoiceItem.payment_method}}
												</label>
											</div>
											<div v-if="invoiceItem && invoiceItem.payment_method === 'Bank Transfer'">
												<div class="d-flex justify-content-between">
													<label class="mr-4 text-navy-light">Bank name</label>
													<label class="text-navy">
														Evolve Bank & Trust
													</label>
												</div>
												<div class="d-flex justify-content-between">
													<label class="mr-4 text-navy-light">ABA Routing Number</label>
													<label class="text-navy">
														084106768
													</label>
												</div>
												<div class="d-flex justify-content-between">
													<label class="mr-4 text-navy-light">Beneficiary Name</label>
													<label class="text-navy">
														SuperSource, Inc
													</label>
												</div>
												<div class="d-flex justify-content-between">
													<label class="mr-4 text-navy-light">Account Number</label>
													<label class="text-navy">
														9800764751
													</label>
												</div>
											</div>
										</div>
									</div>
									<!-- line 3 bill to-->
									<div class="d-flex justify-content-between">
										<div class="text-grey mt-2">
											<div class="text-navy mb-1">Paid by</div>
											<div class="mb-1 text-navy-light">{{invoiceItem && customNameInvoice}}</div>
											<div class="mb-0 text-navy-light">{{invoiceItem && customEmail}}</div>
										</div>
									</div>
									<!-- line 4 total payment -->
									<div class="d-flex">
										<div class="d-flex mt-5 mb-4 text-navy">
											<h2 class="text-navy mr-2">{{amountPaidCustom(invoiceItem && invoiceItem.amount)}}</h2><h2 class="text-navy" v-if="invoiceItem && invoiceItem.due_date">paid on {{convertTimestampCompleteCustom(invoiceItem && invoiceItem.due_date)}}</h2>
										</div>
									</div>
									<!-- table -->
									<table class="table mb-4 bg-white-tb table-striped-grey text-small mb-20">
									<thead>
										<tr class="text-navy">
											<th width="55%" class="fs-13px">{{ $t('Description') }}</th>
											<th class="fs-13px">{{ $t('Qty') }}</th>
											<th width="20%" class="fs-13px">{{ $t('Unit Price') }}</th>
											<th class="fs-13px">{{ $t('Amount') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr class="border-bottom">
											<td class="bg-white-top">
												<div class="mb-4">{{convertTimestampCustom(invoiceItem && invoiceItem.due_date)}}</div>
												<div class="truncate-invoice-title">{{ invoiceItem && invoiceItem.description }}</div>
											</td>
											<td><div class="mb-5"></div> 1 </td>
											<td><div class="mb-5"></div>{{ amountPaidCustom(invoiceItem && customPrice) }}</td>
											<td><div class="mb-5"></div>{{ amountPaidCustom(customPrice * 1) }}</td>
										</tr>
										<tr v-if="invoiceItem && customDiscount" class="">
											<td class="bg-white"></td>
											<td class="bg-white"></td>
											<td>Total Discount</td>
											<div class="bg-navy-light" v-if="invoiceItem && customDiscount">
												<div>
													<td class="bg-navy-light">{{ amountPaidCustom(customDiscount) }}</td>
												</div>
											</div>
											<div v-else>
												<td class="bg-navy-light">$0</td>
											</div>
										</tr>
										<tr>
											<td class="bg-white"></td><td class="bg-white"></td>
											<td class="bg-amount-paid">Amount Due</td>
											<td class="bg-amount-paid">{{ amountPaidCustom(invoiceItem && invoiceItem.amount) }}</td>
										</tr>
									</tbody>
								</table>
								<div><hr></div>
								<div style="position: absoulte; bottom: 0;">Terms and conditions apply <a class="text-navy" href="https://grafiaslive.com/terms-and-condition-23-july-2020/">https://grafiaslive.com/terms-and-condition-23-july-2020/</a></div>
								<span class="text-navy mr-1">Questions?</span><span>Contact SuperSource, Inc at <span class="text-navy mr-1">billing@grafiaslive.com</span> or call at <span class="text-navy mr-1">+1 (302) 289-8007</span>.</span>
								</section>
							</section>
						</vue-html2pdf>
					</div>
					<div @click="generateReport()" class="text-primary ml-3 pl-2 pointer mb-3">Download invoice as PDF</div>
				</div>
			</div>
		</template>
	</modal>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import dayjs from 'dayjs';
import Loading from 'vue-loading-overlay';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import transactionsApi from '@/api/transactions';

export default {
	name: 'InvoiceModal',
	props: {
		data: {
			type: Object,
		},
		isCustomInvoice: {
			type: Boolean,
		},
	},
	components: {
		VueHtml2pdf,
		Modal,
		Loading,
	},
	data() {
		return {
			invoiceItem: null,
			isFetching: false,
			fullPage: true,
			colorOverlay: '#000000',
			colorLoading: '#FFFFFF',
			nameInvoicePdf: '',
			customNameInvoice: '',
			customEmail: '',
			customDiscount: '',
			customPrice: '',
		};
	},
	methods: {
		generateReport() {
			this.$refs.html2Pdf.generatePdf();
		},
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const invoiceItem = response.data;
				this.invoiceItem = invoiceItem;
				this.isFetching = false;
				if (invoiceItem && invoiceItem.bill_to) {
					const personalData = JSON.parse(invoiceItem.bill_to);
					this.customNameInvoice = personalData.name;
					this.customPrice = personalData.price;
					const totalDiscount = (parseInt(personalData.price) * parseInt(personalData.discount)) / 100;
					this.customDiscount = totalDiscount;
					this.customEmail = personalData.email;
				}
				if (!this.isCustomInvoice) {
					this.nameInvoicePdf = `${this.invoiceItem.customer_name}-${invoiceItem.number}`;
				} else {
					this.nameInvoicePdf = `${this.customNameInvoice}-${invoiceItem.invoice_number}`;
				}
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Transactions',
					text: message,
				});
				this.isFetching = false;
			};
			if (this.data && this.data.id) {
				transactionsApi.getInvoice(this.data.id, callback, errorCallback);
			}
		},
		amountPaid(item) {
			if (item === 0) return '$0';
			const itemString = item.toString();
			const index = itemString.indexOf('-');
			if (index !== -1) {
				const removeMin = itemString.substring(1);
				const result = `${removeMin.slice(0, -2)}.${removeMin.slice(-2)}`;
				return `-$${result}`;
			}
			const result = `${itemString.slice(0, -2)}.${itemString.slice(-2)}`;
			return `$${result}`;
		},

		amountPaidCustom(item) {
			if (item === 0) return '$0';
			const itemString = item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			const index = itemString.indexOf('-');
			if (index !== -1) {
				const removeMin = itemString.substring(1);
				const result = removeMin;
				return `-$${result}`;
			}
			const result = itemString;
			return `$${result}`;
		},

		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
		},
		reset() {
		},
		convertTimestamp(time) {
			const date = new Date(time * 1000);
			return dayjs(date).format('MMM DD, YYYY');
		},
		convertTimestampCustom(time) {
			return dayjs(time).format('MMM DD, YYYY');
		},
		convertTimestampComplete(time) {
			const date = new Date(time * 1000);
			return dayjs(date).format('MMMM DD, YYYY');
		},
		convertTimestampCompleteCustom(time) {
			return dayjs(time).format('MMMM DD, YYYY');
		},
	},
	computed: {
		brandCard() {
			return this.invoiceItem && this.invoiceItem.payment_method_details && this.invoiceItem.payment_method_details.card && this.invoiceItem.payment_method_details.card.brand ? this.invoiceItem.payment_method_details.card.brand : '';
		},
		last4DigitCard() {
			return this.invoiceItem && this.invoiceItem.payment_method_details && this.invoiceItem.payment_method_details.card && this.invoiceItem.payment_method_details.card.last4 ? this.invoiceItem.payment_method_details.card.last4 : '';
		},
	},
	created() {
		this.initData();
		this.fetch();
	},
};
</script>
